export const downloadCSV = ({ headers, data, fileName }: { headers: string[]; data: any; fileName: string }) => {
  const link = document.createElement('a');
  link.href = 'data:text/csv;charset=utf-8,' + escape(`${headers.join(',')}\n${data}`);
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
